import React, { useContext } from "react";
import { IconButton, useTheme } from "@material-ui/core";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import ColorModeContext from "../../layout/themeContext";

/** Alterna entre tema claro/escuro (navbar). */
const DarkModeToggle = () => {
  const theme = useTheme();
  const { colorMode } = useContext(ColorModeContext);

  return (
    <IconButton edge="start" onClick={colorMode.toggleColorMode}>
      {theme.mode === "dark" ? (
        <Brightness7Icon style={{ color: "white" }} />
      ) : (
        <Brightness4Icon style={{ color: "white" }} />
      )}
    </IconButton>
  );
};


export default DarkModeToggle;
